// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c2dfcac0","483":"ebb6a993","703":"7be32363","787":"63151f49"}[chunkId] + ".chunk.js";
};